import { Component, Inject, OnInit } from '@angular/core';
import { MmDialogData, MmDialogRefService } from '@metromarkets/components';
import { Router } from '@angular/router';
import {
  APP_ADDRESSES_ROUTE,
  APP_CART_ROUTE,
  APP_CHECKOUT_ROUTE,
  APP_SHIPPING_ROUTE,
  ORDER_ROUTE
} from '~shared/constants';
import { AddressValidationParams } from '../../models';
import { CartNavigatorService } from '~shared/modules/cart-navigator/cart-navigator.service';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { ChangeDeliveryAddressApplicationEvent } from '~shared/modules/application-event/models/change-delivery-address.model';
import { BackToCartApplicationEvent } from '~shared/modules/application-event/models/back-to-cart.model';
import { InvalidOfferForRegionApplicationEvent } from '~shared/modules/application-event/models';

@Component({
  selector: 'app-address-validation-dialog',
  templateUrl: './address-validation-dialog.component.html',
  styleUrls: ['./address-validation-dialog.component.scss']
})
export class AddressValidationDialogComponent implements OnInit {
  postalCode: string;
  region: string;

  constructor(
    private dialogRefService: MmDialogRefService<AddressValidationDialogComponent>,
    private router: Router,
    private cartNavigator: CartNavigatorService,
    private applicationEventService: ApplicationEventService,
    @Inject(MmDialogData) data: AddressValidationParams,
  ) {
    this.postalCode = data.postalCode;
    this.region = `CHECKOUT.ADDRESS_VALIDATION.${data.region}`;
  }

  ngOnInit() {
    this.applicationEventService.publish(new InvalidOfferForRegionApplicationEvent());
  }

  onChangeAddress() {
    this.dialogRefService.close();
    this.router.navigate([
      APP_CHECKOUT_ROUTE,
      APP_CHECKOUT_ROUTE,
      ORDER_ROUTE,
      APP_ADDRESSES_ROUTE,
      APP_SHIPPING_ROUTE
    ]);
    this.applicationEventService.publish(new ChangeDeliveryAddressApplicationEvent());
  }

  onChangeOrder() {
    this.dialogRefService.close();
    this.cartNavigator.navigateToCart().subscribe();
    this.applicationEventService.publish(new BackToCartApplicationEvent());
  }
}
